// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import PauseRoundSvg from '@rsuite/icon-font/lib/status/PauseRound';
var PauseRound = createSvgIcon({
  as: PauseRoundSvg,
  ariaLabel: 'pause round',
  category: 'status',
  displayName: 'PauseRound'
});
export default PauseRound;